/**
 * Created by eriksundqvist on 25/05/16.
 */
import { connect } from 'react-redux';
import { setExpressPayment, setRot, setRut } from 'redux/modules/invoice/index';
import Hsd from './hsd';

function mapStateToProps (state) {
  return {
    expressPayment: state.invoice.expressPayment,
    rot: state.invoice.hsd.rot,
    rut: state.invoice.hsd.rut,
    data: state.invoice.hsd.data,
    apartmentNumber: state.invoice.hsd.apartmentNumber,
    cooperativeApartmentRegistrationNumber: state.invoice.hsd.cooperativeApartmentRegistrationNumber,
    accommodationType: state.invoice.hsd.accommodationType,
    submitted: state.invoice.submitted
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setExpressPayment: (expressPayment) => dispatch(setExpressPayment(expressPayment)),
    setRot: (rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType) =>
      dispatch(setRot(rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType)),
    setRut: (rut) => dispatch(setRut(rut))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Hsd);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/hsd/hsd-container.js
 **/